import firedux from '../firedux'

import {
  USER_IGNORED_USER_ENDPOINT,
  USER_IGNORING_USER_ENDPOINT
} from '../../config/constants'

const toggleIgnoring = (uid, otherUid, isIgnored) => {
  const ENDPOINT = USER_IGNORING_USER_ENDPOINT(uid, otherUid)
  const ref = firedux.ref.child(ENDPOINT)

  return ref.set(isIgnored)
}

const toggleIgnored = (uid, otherUid, isIgnored) => {
  const ENDPOINT = USER_IGNORED_USER_ENDPOINT(uid, otherUid)
  const ref = firedux.ref.child(ENDPOINT)

  return ref.set(isIgnored)
}

export default (currentUserUid, otherUid, isIgnored) => {
  if (!currentUserUid || !otherUid) return Promise.reject()

  return toggleIgnored(currentUserUid, otherUid, isIgnored)
    .then(toggleIgnoring.bind(null, otherUid, currentUserUid, isIgnored))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/toggle_ignored_user.js
 **/